import * as types from './action-types';
import { generations } from '../templates/circle-vertical';

export const GenerationState = (index) => ({
  thickness: generations[index].thickness,
  fontSize: generations[index].fontSize,
  cellType: generations[index].cellType,
  offset: generations[index].offset,
  strokeVisible: true,
  index,
});

export function generationReducer(state = GenerationState(), {payload, type}) {
  switch (type) {
    case types.SET_THICKNESS:
      return Object.assign({}, state, {
        thickness: payload,
      });

    case types.SET_FONT_SIZE:
      return Object.assign({}, state, {
        fontSize: payload,
      });

    case types.SET_CELL_TYPE:
      return Object.assign({}, state, {
        cellType: payload,
      });

    case types.SET_OFFSET:
      return Object.assign({}, state, {
        offset: payload,
      });

    case types.SET_STROKE_VISIBLE:
      return Object.assign({}, state, {
        strokeVisible: payload,
      });

    // case types.SET_HIDDEN:
    //   return Object.assign({}, )
    
    default: 
      return state;

  }
}


// WEBPACK FOOTER //
// ./src/core/generations/generation-reducer.js